import {
  EXTERNAL_DATA_STATUS,
  TpExternalData,
  TpExternalDataResult,
  TpExternalDataType,
  addRequest,
  getExternalDataRequestId,
  setRequestContent,
} from './externalDataSlice';

import { xml2json } from 'xml-js';

function parsePubmedAbstract(respText: string): any {
  const respJson = JSON.parse(xml2json(respText, { compact: true, spaces: 4 }));
  const article = respJson.PubmedArticleSet.PubmedArticle.MedlineCitation.Article;
  const abstract = article.Abstract;
  if (!Array.isArray(abstract.AbstractText)) {
    return abstract.AbstractText._text;
  } else {
    const elems = abstract.AbstractText.map((elem: any, idx: number) => (
      <div key={idx}>
        <b>{elem._attributes.Label}</b>
        <br />
        {elem._text}
      </div>
    ));
    return elems;
  }
}

export function getExternalData(dataType: TpExternalDataType, query: any, externalData: TpExternalData, dispatch: any) {
  const requestId = getExternalDataRequestId(dataType, query);

  if (!externalData.requests[requestId]) {
    const request: TpExternalDataResult = {
      dataType,
      query,
      status: EXTERNAL_DATA_STATUS.PENDING,
      content: null,
    };

    dispatch(addRequest({ request }));

    // @todo: this stuff should not be hard-wired here, only for the prototype!

    // @todo: we need proper error handling at all levels! (fetch, xml parsing...)

    const url = `https://eutils.ncbi.nlm.nih.gov/entrez/eutils/efetch.fcgi?db=pubmed&id=${query.pmid}&retmode=XML&rettype=abstract`;

    fetch(url)
      .then((resp) => resp.text())
      .then((respText) => {
        dispatch(setRequestContent({ requestId, content: parsePubmedAbstract(respText) }));
      });

    return request;
  }

  return externalData.requests[requestId];
}
